<template>
  <nav>
    <router-link to="/forwards">
      <div class="side-menu-icon">
        <fa-icon :icon="['fal', 'exchange']"/>
      </div>
      <span class="side-menu-label">Movimentações</span>
    </router-link>
    <router-link to="/partners">
      <div class="side-menu-icon">
        <fa-icon :icon="['fal', 'handshake']"/>
      </div>
      <span class="side-menu-label">Parceiros</span>
    </router-link>
    <router-link to="/settings">
      <div class="side-menu-icon">
        <fa-icon :icon="['fal', 'ellipsis-h-alt']"/>
      </div>
      <span class="side-menu-label">Outros recursos</span>
    </router-link>
  </nav>
</template>

<script>
export default {};
</script>
